export default class Rater {
  constructor(id, name, age, specifics, imageURL) {
    this.id = id;
    this.name = name;
    this.age = age;
    this.specifics = specifics;
    this.imageURL = imageURL;
  }

  static fromJson(json) {
    return new Rater(
      json.id || json.userId || null,   // 🔥 поддерживаем оба варианта
      json.name || "Аноним",
      json.age || "Не указан",
      json.specifics || "Не указано",
      json.imageURL || ""
    );
  }
}